import type { FC } from 'react';
import { isMobile } from 'react-device-detect';
import { NoSSR } from '@mwl/ui';
import { DatepickerDynamic } from '@/components/DatepickerDynamic/DatepickerDynamic';
import { DatepickerNative } from '@/components/DatepickerNative/DatepickerNative';
import type { DatepickerAdaptiveProps } from './DatepickerAdaptive.types';
const DatepickerAdaptive: FC<DatepickerAdaptiveProps> = ({
  adaptive,
  ...props
}) => {
  return <NoSSR data-sentry-element="NoSSR" data-sentry-component="DatepickerAdaptive" data-sentry-source-file="DatepickerAdaptive.tsx">{adaptive && isMobile ? <DatepickerNative {...props} /> : <DatepickerDynamic {...props} />}</NoSSR>;
};
export { DatepickerAdaptive };